/**
 * Actions have a type that where the name will show up in logs.
 */
export enum AccountActions {
  cancelSignOut = 'account/signOut/cancel',
  submitSignOut = 'account/signOut/submit',
  submitSignOutSuccess = 'account/signOut/success',
  submitSignOutFailed = 'account/signOut/failed',
  showLeaveOrgDialog = 'organization/leave/show',
  submitLeaveOrganization = 'organization/leave/submit',
  cancelLeaveOrganization = 'organization/leave/cancel',
  leavingOrganization = 'organization/leaving',
  submitLeaveOrganizationSuccess = 'organization/leave/success',
  submitLeaveOrganizationFailed = 'organization/leave/failed',
  redirectBack = 'organization/leave/redirect',
  getSsprConvergenceEnabled = 'account/mygroups/is-sspr-convergence-enabled',
  getSsprConvergenceEnabledResponse = 'account/mygroups/is-sspr-convergence-enabled/success',
  getSsprConvergenceFailed = 'account/mygroups/is-sspr-convergence-enabled/failed',
  getConvergedUXV2Enabled = 'account/mygroups/is-converged-uxv2-enabled',
  getConvergedUXV2EnabledResponse = 'account/mygroups/is-converged-uxv2-enabled/success',
  getConvergedUXV2Failed = 'account/mygroups/is-converged-uxv2-enabled/failed',
  getOfficeLicenses = 'account/office-licenses',
  getOrganizations = 'account/get-organizations',
  getNavBarData = 'account/get-navbar-data',
  getEnabledApps = 'account/get-enabled-apps',
  getCurrentOrganization = 'account/get-current-organization',
  getUser = 'account/get-user',
}
